// extracted by mini-css-extract-plugin
module.exports = {"icon":"OpenFilterWithActions_icon__3ZFR-"};